module.exports = __webpack_public_path__ + "img/motor.2ffdf694.svg";